<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>云药房中药材用药统计</span>
      <el-button type="primary"
                 style="width: 92px"
                 @click="back"
                 size="medium">返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="title space_between">
          <span>基本信息</span>
        </div>
        <div style="padding: 0 30px">
          <div style="margin-bottom: 16px">
            <span style="font-size: 18px">{{ info.goods_name }}</span>
            <span v-if="routeQuery.dosage_form">（{{ info.drug_type_name }}）</span>
          </div>
          <div class="infobox">
            <div class="infoitem">
              <span>统计起始时间：</span>
              <span>{{ info.create_time }}</span>
            </div>
            <div class="infoitem">
              <span>非校正用量：</span>
              <span>{{ info.item_use_level ? info.item_use_level : 0 }}g</span>
            </div>
            <div class="infoitem">
              <span>校正后用量：</span>
              <span>{{ info.jafter ? info.jafter : 0 }}g</span>
            </div>
            <div class="infoitem">
              <span>企标用量：</span>
              <span>{{ info.qafter ? info.qafter : 0 }}g</span>
            </div>
            <div class="infoitem">
              <span>新标用量：</span>
              <span>{{ info.xafter ? info.xafter : 0 }}g</span>
            </div>
            <div class="infoitem">
              <span>正校正量：</span>
              <span>+{{ info.just ? info.just : 0 }}g</span>
            </div>
            <div class="infoitem">
              <span>负校正量：</span>
              <span>{{ info.neg ? info.neg : 0 }}g</span>
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName"
                 class="tabs-box">
          <el-tab-pane label="检索"
                       name="1"></el-tab-pane>
          <el-tab-pane label="用量详情"
                       name="2"></el-tab-pane>
        </el-tabs>
        <component :is="currentComponent"
                   :info="info" />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import system from '@/api/system.js';
import Pagination from '@/components/Pagination/index';
import Correcting from './Correcting.vue';
import DosageInfo from './DosageInfo.vue';
export default {
  components: {
    Pagination,
    Correcting,
    DosageInfo
  },
  data() {
    return {
      activeName: '1',
      info: {}
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    currentComponent() {
      switch (this.activeName) {
        case '1':
          return Correcting;
        case '2':
          return DosageInfo;
        default:
          return Correcting;
      }
    },
    routeQuery() {
      return this.$route.query;
    }
  },
  created() {
    // this.drug_id = this.$route.query.drug_id;
    // this.hospital_id = this.$route.query.hospital_id;
    // this.drug_type_pid = this.$route.query.drug_type_pid;
    // this.dosage_form = this.$route.query.dosage_form;
    // this.type = this.$route.query.type;
    this.activeName = this.routeQuery.activeName
      ? this.routeQuery.activeName.toString()
      : '1';
    this.getInfo();
  },
  methods: {
    //获取详情
    getInfo() {
      let data = {};
      let url = '';
      let { drug_id, hospital_id, drug_type_pid, dosage_form, type } =
        this.routeQuery;
      if (type == 1) {
        data = {
          drug_id,
          hospital_id,
          drug_type_pid
        };
        url = 'platform/hospital/getHospitalpidGoodsCorrectInfo';
      }
      if (type == 2) {
        data = {
          drug_id,
          dosage_form
        };
        url = 'platform/hospital/getGoodsCorrectInfo';
      }
      if (type == 3) {
        data = {
          drug_id,
          dosage_form,
          hospital_id
        };
        url = 'platform/hospital/getdetailpidGoodsCorrectInfo';
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.info = res.data.info;
          this.info.create_time = this.info.create_time
            ? dayjs.unix(this.info.create_time).format('YYYY-MM-DD')
            : '';
        }
      });
    },
    back() {
      history.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.title {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 16px;
}
.infobox {
  display: flex;
  flex-wrap: wrap;
  .infoitem {
    width: 30%;
    margin-bottom: 20px;
  }
}
.tabs-box {
  ::v-deep .el-tabs__item {
    font-weight: bold;
    font-size: 16px;
  }
}
</style>